import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import { AiChangeType } from '../../../../../../../ai';
import { SingleChoiceAddQuestionStrategy } from './single-choice-add.strategy';
import { SingleChoiceDeleteQuestionStrategy } from './single-choice-delete.strategy';
import { SingleChoiceUpdateQuestionStrategy } from './single-choice-update.strategy';
export var SingleChoiceAiChangeStrategyFactory = /*#__PURE__*/function () {
  function SingleChoiceAiChangeStrategyFactory() {
    _classCallCheck(this, SingleChoiceAiChangeStrategyFactory);
  }

  _createClass(SingleChoiceAiChangeStrategyFactory, null, [{
    key: "create",
    value: function create(context) {
      switch (context.changeType) {
        case AiChangeType.Add:
          return new SingleChoiceAddQuestionStrategy(context);

        case AiChangeType.Update:
          return new SingleChoiceUpdateQuestionStrategy(context);

        case AiChangeType.Delete:
          return new SingleChoiceDeleteQuestionStrategy(context);

        default:
          throw new Error('Unsupported change type for single choice');
      }
    }
  }]);

  return SingleChoiceAiChangeStrategyFactory;
}();